<section class="motivation-courses-area pt-100">
    <div class="">
        <div class="section-title">
            <span class="sub-title">DECOUVREZ NOUS A TRAVERS</span>
            <h2>Nos axes d'intervention</h2>
        </div>

        <div class="row justify-content-center">
            <div class="col-8">
                <p class="inter-intro">Nos actions s'articulent autour de plusieurs axes essentiels pour garantir
                     une éducation de qualité et un accompagnement adapté. Chaque intervention est pensée pour répondre
                     aux besoins spécifiques des apprenants et favoriser leur épanouissement.</p>
            </div>
        </div>

        <div class="row justify-content-center mt-5">
            <div class="col-12">
                <div class="row justify-content-center mt-2">
                    <div class="m-1 col-xl-3 col-lg-4 col-md-6">
                        <div class="card-inter single-motivation-courses-item mb-30">
                            <div class="courses-image text-center">
                                <a href="#" class="d-block"><img src="assets/images/new/interventions/accompagnement.svg" alt="image"></a>
                            </div>
                            <div class="courses-content">
                                <h3><a href="#" class="d-inline-block inter-title mt-3">Accompagnement et coaching scolaire</a></h3>
                                <div class="courses-rating">
                                    <div class="rating-total inter-desc">
                                        Nous aidons votre enfant à découvrir son style d’apprentissage afin de l’amener à réaliser son plein potentiel.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-6">
                        <div class="card-inter single-motivation-courses-item mb-30">
                            <div class="courses-image text-center">
                                <a href="#" class="d-block"><img src="assets/images/new/interventions/consultation.svg" alt="image"></a>
                            </div>
                            <div class="courses-content">
                                <h3><a href="#" class="d-inline-block inter-title mt-3">Consultation en éducation et apprentissage</a></h3>
                                <div class="courses-rating">
                                    <div class="rating-total inter-desc">
                                        Nous décelons les blocages qui entravent l’apprentissage de votre enfant et l’aidons à les surmonter pour évoluer.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-6">
                        <div class="card-inter single-motivation-courses-item mb-30">
                            <div class="courses-image text-center">
                                <a href="#" class="d-block"><img src="assets/images/new/interventions/insertion.svg" alt="image"></a>
                            </div>
                            <div class="courses-content">
                                <h3><a href="#" class="d-inline-block inter-title mt-3">Coaching pour l'insertion sociale et professionnelle</a></h3>
                                <div class="courses-rating">
                                    <div class="rating-total inter-desc">
                                        Nous vous aidons à développer les attitudes et habiletés nécessaires pour être employable et vivre en société.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="row justify-content-center mt-4">
                    <div class="col-xl-3 col-lg-4 col-md-6">
                        <div class="card-inter single-motivation-courses-item mb-30">
                            <div class="courses-image text-center">
                                <a href="#" class="d-block"><img src="assets/images/new/interventions/leadership.svg" alt="image"></a>
                            </div>
                            <div class="courses-content">
                                <h3><a href="#" class="d-inline-block inter-title mt-3">Consultation et coaching en entrepreneuriat</a></h3>
                                <div class="courses-rating">
                                    <div class="rating-total inter-desc">
                                        Nous vous aidons à clarifier vos idées d’entreprise et à définir un bon modèle éconimique de business.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="col-xl-3 col-lg-4 col-md-6">
                        <div class="card-inter single-motivation-courses-item mb-30">
                            <div class="courses-image text-center">
                                <a href="#" class="d-block"><img src="assets/images/new/interventions/audi.svg" alt="image"></a>
                            </div>
                            <div class="courses-content">
                                <h3><a href="#" class="d-inline-block inter-title mt-3">Audit de gestion des organisationst</a></h3>
                                <div class="courses-rating">
                                    <div class="rating-total inter-desc">
                                        Nous diagnostiquons les problèmes qui ralentissent le développement des organisations et entreprises et proposons des solutions optimales.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-6">
                        <div class="card-inter single-motivation-courses-item mb-30">
                            <div class="courses-image text-center">
                                <a href="#" class="d-block"><img src="assets/images/new/interventions/formation.svg" alt="image"></a>
                            </div>
                            <div class="courses-content">
                                <h3><a href="#" class="d-inline-block inter-title mt-3">Formation</a></h3>
                                <div class="courses-rating">
                                    <div class="rating-total inter-desc">
                                        Nous vous aidons à acquérir des compétences pratiques et opérationnelles certifiées.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row justify-content-center">
                    <div class="col-lg-12 col-md-12 text-center">
                        <div class="courses-info-wrap">
                            <!-- <button type="button"></button> -->
                            <p class="inter-foot">Protégeons l'enfant, Eduquons l'enfant, Accompagnons l'enfant dans sa croissance pour son bien-être. <a routerLink="/register">Inscrivez le !</a>.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>